import { render } from "./EditAproposPage.vue?vue&type=template&id=d5fc35b8&ts=true"
import script from "./EditAproposPage.vue?vue&type=script&lang=ts"
export * from "./EditAproposPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__